import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import {
  provideBcfActivatedRoute,
  type BcfActivatedRoute
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import type { Params } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/types';
import {
  provideLocalStorageService,
  type LocalStorageService
} from '@bcf2-v1-ui-shared/local-storage/local-storage.service';
import { combineLatest, first, map } from 'rxjs';

export class HomeOrIntroPreventerService {
  constructor(
    private _activatedRoute: BcfActivatedRoute,
    private _localStorage: LocalStorageService
  ) {}

  public checkAndPrevent(): void {
    combineLatest([this._activatedRoute.queryParams, this._activatedRoute.fragment])
      .pipe(
        map(([queryParams, fragment]: [Params, string | undefined]) =>
          Boolean(Object.keys(queryParams).length > 0 || (fragment && fragment.length > 0))
        ),
        first((alreadySeen: boolean) => alreadySeen === true)
      )
      .subscribe(() => this._localStorage.setBoolean('introSeenAlready', true));
  }
}

export function provideHomeOrIntroPreventerService(): HomeOrIntroPreventerService {
  return provideSingleton(
    HomeOrIntroPreventerService,
    () => new HomeOrIntroPreventerService(provideBcfActivatedRoute(), provideLocalStorageService())
  );
}
